import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { useAsync } from '../lib/useAsync';
import { Badge, Button, Card, EmptyState, ErrorAlert, PageHeader, Pagination, Spinner } from '../components/ui';
import { formatDate, truncate } from '@kontentowo/shared';

export function PublishingPage() {
  const { data, error, loading, reload } = useAsync(() => api.content.list({ status: 'SCHEDULED,APPROVED,PUBLISHED,FAILED' }), []);
  const [busy, setBusy] = useState<string | null>(null);
  const [actionError, setActionError] = useState<unknown>(null);
  const [lastResult, setLastResult] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const pageSize = 10;

  const publish = async (id: string) => {
    setBusy(id);
    setActionError(null);
    setLastResult(null);
    try {
      const res = await api.content.publish(id);
      setLastResult(`Opublikowano ${res.results.filter((r) => r.status === 'SUCCESS').length}/${res.results.length} wariantów (mock).`);
      reload();
    } catch (err) {
      setActionError(err);
    } finally {
      setBusy(null);
    }
  };

  const items = data ?? [];

  return (
    <>
      <PageHeader
        title="Publishing"
        subtitle="MVP używa MockPublisher. Prawdziwe kanały (Sociamonials/Telegram) aktywują się po ustawieniu PUBLISH_LIVE=true."
      />
      {loading && <Spinner />}
      {error && <ErrorAlert error={error} />}
      <ErrorAlert error={actionError} />
      {lastResult && <div className="alert alert--success">{lastResult}</div>}

      {!loading && items.length === 0 && <EmptyState icon="➤" title="Brak treści do publikacji" hint="Zatwierdź i zaplanuj content." />}

      {items.length > 0 && (
        <Card flush>
          <table className="table">
            <thead>
              <tr>
                <th>Temat</th>
                <th>Brand</th>
                <th>Status</th>
                <th>Updated</th>
                <th style={{ textAlign: 'right' }}>Akcje</th>
              </tr>
            </thead>
            <tbody>
              {items.slice((page - 1) * pageSize, page * pageSize).map((item) => (
                <tr key={item.id}>
                  <td>
                    <Link to={`/content/${item.id}`}>{truncate(item.topic, 56)}</Link>
                  </td>
                  <td className="muted">{item.brand?.name ?? '—'}</td>
                  <td>
                    <Badge tone={item.status === 'PUBLISHED' ? 'success' : item.status === 'FAILED' ? 'danger' : 'info'}>{item.status}</Badge>
                  </td>
                  <td className="muted">{formatDate(item.updatedAt)}</td>
                  <td>
                    <div className="btn-row" style={{ justifyContent: 'flex-end' }}>
                      {(item.status === 'SCHEDULED' || item.status === 'APPROVED') && (
                        <Button size="sm" variant="primary" disabled={busy === item.id} onClick={() => publish(item.id)}>
                          {busy === item.id ? 'Publikowanie…' : 'Publish'}
                        </Button>
                      )}
                      <Link className="btn btn--sm" to={`/content/${item.id}`}>
                        Details
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination page={page} pageSize={pageSize} total={items.length} onChange={setPage} />
        </Card>
      )}
    </>
  );
}
